import { Form } from 'formik';
import { FormikDebounce } from '../common/form/FormikDebounce';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import * as Yup from 'yup';
import { FormContainer } from '../common/form/FormContainer';
import { SubmitButton } from '../common/form/SubmitButton';
import { SupplierAutocomplete } from '../common/form/SupplierAutocomplete';
import { ShowError } from '../ShowError';
import { resources } from '@api/resources';

interface Props {
  onClose: () => void;
  onSupplierSelectClick: (supplier: string) => void;
}

export const CreateSupplierEmployee: FC<Props> = ({ onClose, onSupplierSelectClick }) => {
  const { t } = useTranslation();

  const handleSubmit = async (values: any) => {
    onSupplierSelectClick(values.supplier.id);
    onClose();
  };

  return (
    <FormikDebounce<any>
      initialValues={{
        supplier: undefined,
        supplierEmployee: undefined,
      }}
      validationSchema={Yup.object({
        supplier: Yup.object().required(),
      })}
      onSubmit={handleSubmit}
    >
      <Form>
        <FormContainer>
          <FormContainer>
            <SupplierAutocomplete name="supplier" label={t('visitation.supplier')} required={true} disabled={false} />
          </FormContainer>

          <ShowError resource={resources.querySupplierEmployees} />
          <SubmitButton />
        </FormContainer>
      </Form>
    </FormikDebounce>
  );
};
